import React from 'react'

import { ScreenWidth, useIsMobile } from 'shared/js/utils/WindowContext'

import { DesktopLeftNav } from './DesktopLeftNav'
import { MobileLeftNav } from './MobileLeftNav'
import { MenuGroup } from './types'

export type LeftMenuPanelProps = {
  isOpen: boolean
  menuGroups: MenuGroup[]
  selectedGroup: MenuGroup | null
  initialSelectedChild?: MenuGroup | null
  currentCategorySlug?: string
  onClose: () => void
  onGroupSelect?: (group: MenuGroup) => void
  setFilters: React.Dispatch<React.SetStateAction<Set<string>>>
}

export const LeftMenuPanel = (props: LeftMenuPanelProps) => {
  const isMobile = useIsMobile(ScreenWidth.SMALL)

  if (isMobile) {
    return <MobileLeftNav {...props} />
  }

  return <DesktopLeftNav {...props} />
}
